export const date = "dnbxo37";
export const container = "c1uclbea";
export const hideOnMobile = "hn1q2fr";
export const hideOnDesktop = "h1bg66hd";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");